import React, { useState } from "react";
import PropTypes from "prop-types";
import { Card, Icon } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import AntecedentesShow from "layouts/escuela/data-tables/estudiantes/AntecedentesShow";
import AntecedenteForm from "layouts/escuela/ModalCreate/NewAntecedente/AntecedenteForm";

const AntecedenteTab = ({ student }) => {
  const [showAntecedenteForm, setShowAntecedenteForm] = useState(false);

  if (showAntecedenteForm) {
    return (
      <MDBox mt={2}>
        <Card sx={{ overflow: "visible", padding: 2 }}>
          <AntecedenteForm
            estudianteUrl={student.url}
            nombreEstudiante={`${student.nombre || ""} ${student.apellido_paterno || ""}`}
            curpEstudiante={student.curp}
            onSuccess={() => setShowAntecedenteForm(false)}
            onCancel={() => setShowAntecedenteForm(false)}
          />
        </Card>
      </MDBox>
    );
  }

  return (
    <MDBox mt={2}>
      <AntecedentesShow rowData={{ id: student.id }} stretch />

      <MDBox display="flex" justifyContent="center" mt={3}>
        <MDButton
          variant="gradient"
          color="info"
          startIcon={<Icon>add</Icon>}
          onClick={() => setShowAntecedenteForm(true)}
        >
          Agregar Antecedente
        </MDButton>
      </MDBox>
    </MDBox>
  );
};

AntecedenteTab.propTypes = {
  student: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    url: PropTypes.string.isRequired,
    nombre: PropTypes.string,
    apellido_paterno: PropTypes.string,
    curp: PropTypes.string,
  }).isRequired,
};

export default AntecedenteTab;
